import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

import { CallInfoType, CallInitialStateType, CallType } from 'store/calls/calls.types';
import { AccessRights, UserType } from 'store/user/user.types';
import { TCallCheckList } from 'store/checkLists/namespaces/responses';
import { BlockBox } from 'components/common';
import { TUpdateCurrentCallCheckListAnswerById } from 'store/checkLists/namespaces/payloads';

import CallBodyButtons from '../CallBodyButtons/CallBodyButtons';
import CallsCheckLists from '../CallsCheckLists/CallsCheckLists';
import './styles.css';

interface IOwnProps {
	language: string;
	paramsDivRef: React.LegacyRef<HTMLDivElement>;
	callInfo: CallInfoType;
	currentCall: CallInitialStateType['currentCall'];
	accessRights: AccessRights | null;
	isCheckListsLoading: boolean;
	checkLists: TCallCheckList[];
	isAuth: boolean | 'loading';
	classes: Record<string, string>;
	userInfo: UserType | null;
	currentPage: number | undefined;
	showParams?: boolean;

	updateCheckList(target: TUpdateCurrentCallCheckListAnswerById): void;
}

const CallBodyCallParams: React.FC<IOwnProps> = ({
	language,
	paramsDivRef,
	classes,
	callInfo,
	currentCall,
	accessRights,
	checkLists,
	isCheckListsLoading,
	isAuth,
	updateCheckList,
	userInfo,
	currentPage,
	showParams = true,
}) => (
	<div ref={paramsDivRef} className={classes.callBodyCallParams}>
		{showParams && (
			<CallBodyButtons
				isAuth={isAuth}
				language={language}
				callInfo={callInfo}
				currentCall={currentCall}
				userInfo={userInfo}
				currentPage={currentPage}
			/>
		)}

		{accessRights?.checklist_view &&
			(isCheckListsLoading ? (
				<BlockBox margin="16px 0 0" height="auto">
					<div className="CallBodyCallParamsLoader">
						<CircularProgress />
					</div>
				</BlockBox>
			) : (
				<CallsCheckLists
					canUpdateChecklists={accessRights && accessRights.checklist_update}
					currentCall={currentCall as CallType}
					updateCheckList={updateCheckList}
					checkLists={checkLists}
					language={language}
					callCheckListDisabled={!accessRights?.checklist_update}
				/>
			))}
	</div>
);

export default React.memo(CallBodyCallParams);
